import apiMiddleware from "../../../api/apiMiddleware";

export const listActivities = async (page = 1, search = "", filters = {}) => {
  const params = new URLSearchParams();
  params.append("page", String(page));
  params.append("per_page", String(filters.per_page || 10));
  if (search) params.append("search", search);
  if (filters.submission_status) params.append("submission_status", filters.submission_status);
  if (filters.is_approved !== undefined && filters.is_approved !== "") {
    params.append("is_approved", String(filters.is_approved));
  }

  const response = await apiMiddleware.get(`/activities?${params.toString()}`);
  const pagination = response.data?.data || {};

  return {
    data: pagination.data || [],
    current_page: pagination.current_page || 1,
    last_page: pagination.last_page || 1,
    total: pagination.total || 0,
    per_page: pagination.per_page || 10,
  };
};

export const updateActivitySettings = async (activityId, data) => {
  const payload = {
    is_approved: Number(data.is_approved),
    is_active: Number(data.is_active) === 1 ? 1 : 0,
    popular: Number(data.popular) === 1 ? 1 : 0,
    recommended: Number(data.recommended) === 1 ? 1 : 0,
  };
  const response = await apiMiddleware.put(`/activity-settings/${activityId}`, payload);
  return response.data;
};

export const getActivityById = async (activityId) => {
  const response = await apiMiddleware.get(`/activities/${activityId}`);
  return response.data;
};

